import React, {useState} from "react";
import {observer} from "mobx-react";
import {Space, Table, Typography} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {useArticle} from "../../../article.context";
import {columnsFactory} from "./article.data.prices.colums";
import {Price} from "../../../../../../models/articles/articles.prices";
import {ChangeHistoryModal} from "./modal/change-history/change-history.modal";
import {ChangePriceModal} from "./modal/change-price/change-price.modal";

export const ArticleDataPrices: React.FC = observer(() => {
    const t = useTranslate();
    const {article, reload} = useArticle();

    const [modalHistoryItem, setModalHistoryItem] = useState<Price | null>(null);
    const [modalChangePriceItem, setModalChangePriceItem] = useState<Price | null>(null);

    const columns = columnsFactory(t, setModalHistoryItem, setModalChangePriceItem);

    return (
        <Space direction={"vertical"} size={0}>
            <Typography.Title level={3}>{t("ARTICLES.PRICES.TITLE")}</Typography.Title>
            <Table
                columns={columns}
                rowKey={"id"}
                dataSource={[...article.prices]}
                scroll={{x: true}}
                pagination={false}
            />
            {modalHistoryItem ? (
                <ChangeHistoryModal
                    article={article}
                    price={modalHistoryItem}
                    onClose={() => setModalHistoryItem(null)}
                />
            ) : null}
            {modalChangePriceItem ? (
                <ChangePriceModal
                    article={article}
                    price={modalChangePriceItem}
                    onClose={() => {
                        setModalChangePriceItem(null)
                        reload()
                    }}
                />
            ) : null}
        </Space>
    );
})
